import { ApplicationFrame } from "@nulogy/components";
import ConfirmModal from "components/common/ConfirmModal";
import ApplicationContext from "domain/ApplicationContext";
import useApplicationContext from "hooks/apollo/applicationContext/useApplicationContext";
import React from "react";
import ApplicationNavBar from "./navbar/ApplicationNavBar";
import SparkApplicationLayout from "./spark/SparkApplicationLayout";

function ApplicationLayoutView({ children, applicationContext: { trainingMode } }) {
  // The prop carries settings as the raw JSON string; the hook parses it, as ApplicationNavBar does.
  const parsedApplicationContext = useApplicationContext();

  if (ApplicationContext.isSparkNavEnabled(parsedApplicationContext)) {
    return <SparkApplicationLayout>{children}</SparkApplicationLayout>;
  }

  return (
    <ApplicationFrame
      className="appContainer ps-app-content"
      navBar={<ApplicationNavBar environment={trainingMode && "TRAINING"} />}
    >
      {children}
      <ConfirmModal />
    </ApplicationFrame>
  );
}

export default ApplicationLayoutView;
